import React from "react";
import {Toggle} from "@rescui/toggle";
import {useLocation, useNavigate} from "react-router-dom";
import {ProjectsLink} from "../../pages/Projects";

export function GridModeNavigation() {
  const location = useLocation(), navigate = useNavigate();
  const active = /^\/grid(?:\/|$)/.test(location.pathname);
  return <nav className="default-scene-row" aria-label="Grid workspaces">
    <Toggle size="s" checked={active} aria-label="Grid mode" onChange={() => navigate(active ? "/" : "/grid")}>Grid mode</Toggle>
    <ProjectsLink className="default-scene-btn" />
  </nav>;
}
